<script setup lang="ts">
import type { NavigationItem } from '~~/src/composables/useNavigationData'

const props = defineProps<Props>()

defineOptions({
  name: 'NavigationFilterButton',
})

interface Props {
  item: NavigationItem
}

const route = useRoute()

const isActive = computed(() => route.path === props.item.href)
</script>

<template>
  <a
    :href="item.href"
    class="filter-button"
    :class="{ 'is-active': isActive }"
    :aria-label="item.title"
  >
    <component
      :is="item.icon"
      :size="20"
      :class="isActive ? 'text-gray-900' : 'text-gray-600'"
    />
  </a>
</template>

<style lang="scss" scoped>
.filter-button {
  @apply
    flex
    items-center
    justify-center
    h-10
    w-10
    p-0
    rounded-md
    hover:bg-gray-100
    transition-colors
    duration-200
    shrink-0;

  &.is-active {
    @apply bg-gray-100;
  }
}
</style>
